import BaseModel from './base';

export const PAYMENT_METHOD_TYPE = {
	CARD: 'card', // Card will also enclose payment methods with wallets.
	PAYPAL: 'paypal',
	LINK: 'link'
};

export const PRICE_NAMES = {
	TRIAL: 'trial',
	MONTHLY: 'monthly',
	QUARTETLY: 'quarterly',
	YEARLY: 'yearly'
};

export const PAYMENT_STATUS = {
	PENDING: 'pending',
	PAID: 'paid',
	ERROR: 'error',
	CANCELED: 'canceled'
};

export const PAYMENT_TYPE = {
	REFUND: 'refund',
	PAYMENT: 'payment',
	DISPUTE: 'dispute'
};

class Payment extends BaseModel {
	/**
	 * Get currencies list
	 * */
	getCurrencies() {
		return this.get('/currencies');
	}

	/**
	 * Get all application prices.
	 */
	async getPrices({ country, currency, filterActive = false } = {}) {
		const queryParams = new URLSearchParams();
		if (country) {
			queryParams.append('country', country);
		}
		if (currency) {
			queryParams.append('currency', currency);
		}

		const response = await this.get(`/prices?${queryParams.toString()}`, {
			completeResponse: true
		});

		const prices = await response.json();

		const { headers = {} } = response || {};

		if (!filterActive) {
			return { prices, headers };
		}

		return { prices: prices.filter(price => price.active), headers };
	}

	async getByUserId({ params = {} }) {
		const queryParams = new URLSearchParams(params);

		const result = await this.get(`?${queryParams}`);

		return result;
	}

	getByHandlerId(handlerId) {
		return this.get(`/${handlerId}`);
	}
}

export default new Payment('/payment');
